<div class="libero-app-container">
  @if (!translationsLoaded || localDataUpdating) {
    <div class="app-loader-container">
      <libero-preload-spinner></libero-preload-spinner>
    </div>
  } @else if (!showAppContent) {
    <div class="app-loader-container">
      <libero-preload-spinner></libero-preload-spinner>
    </div>
  } @else if (viewBiometricOverlay) {
    <div class="phone-overlay biometry-locked-overlay">
      <svg-icon src="assets/logo/logo.svg" [svgStyle]="{ 'width.px':200 }"></svg-icon>
      <svg-icon
        src="assets/icons/lock.svg"
        [svgStyle]="{ 'width.px':120 }"
      ></svg-icon>
    </div>
  } @else if (viewNeedUpdateOverlay) {
    <div class="phone-overlay need-update-overlay">
      <svg-icon src="assets/icons/arrows-spin.svg"
        [svgStyle]="{ 'width.px':59, 'height.px':59 }"
      ></svg-icon>
      <h2>{{ 'overlay.update.title' | translate }}</h2>
      <p>{{ 'overlay.update.text1' | translate }}</p>
      <p>{{ 'overlay.update.text2' | translate }}</p>
      <libero-button
        label="{{ 'overlay.update.button' | translate }}"
        btnClasses="btn--primary btn--overlay"
        (click)="goToAppStore()"
      ></libero-button>
    </div>
  } @else {
    @if (loggedUser) {
      <libero-header></libero-header>
    }
    <div
      class="libero-content"
      [ngClass]="{ 'libero-content--login': !loggedUser }"
      [ngStyle]="{ 'padding-top.px': nativeSafeZoneService.paddings.top }"
    >
      @if (loggedUser) {
        <div class="disclaimers" [ngStyle]="{ 'padding-top.px': nativeSafeZoneService.paddings.top }">
          <libero-disclaimer></libero-disclaimer>
          <libero-liquidation-disclaimer></libero-liquidation-disclaimer>
        </div>
      }
      <router-outlet></router-outlet>
    </div>
    @if (loggedUser) {
      <libero-client-footer></libero-client-footer>
    } @else {
      <libero-unauth-footer></libero-unauth-footer>
    }
  }
</div>

<libero-modal></libero-modal>
